<h4>{{title}}</h4>

<form
    id="additionalsForm"
    name="additionalsForm"
    novalidate
    autocomplete="off"
    #additionalsForm="ngForm">
    @if (isPlanReleaseConsentApplicable()) {
    <div class="group">
        <div class="container-fluid well">
            <h5>Release consent</h5>
            <div class="col-xs-12">
                @if (additionalsViewModel.planReleaseConsent) {
                <div class="row">
                    <span>Release consent was given at lodgement</span>
                </div>
                } @if (!additionalsViewModel.planReleaseConsent) {
                <div class="row">
                    @if (postReleaseConsentGranted()) {
                    <span> Release consent was given {{additionalsViewModel.postReleaseConsentDate | date:"dd-MMM-yyyy HH:mm"}} </span>
                    } @if (!postReleaseConsentGranted()) {
                    <div class="checkbox">
                        <label
                            class="control-label"
                            for="postPlanReleaseConsent"
                            [hidden]="true"
                            >{{consentDesc}}</label
                        >
                        <div
                            class="checkbox-inline"
                            title="Select to consent to the release of this plan to the planning authority">
                            <i
                                class="nlrp-icon"
                                [ngClass]="{'active': additionalsViewModel.postReleaseConsent, 'nlrp-icon-check-box-selected': additionalsViewModel.postReleaseConsent, 'nlrp-icon-check-box-unselected': !additionalsViewModel.postReleaseConsent}"
                                (click)="postPlanReleaseConsentHandler()">
                            </i>
                            <span>{{consentDesc}}</span>
                            @if (lodgeAdditionalsEnabled && (additionalsPermissions | hasPermissions)) {
                            <input
                                type="checkbox"
                                name="postPlanReleaseConsent"
                                id="postPlanReleaseConsent"
                                [(ngModel)]="additionalsViewModel.postReleaseConsent"
                                style="visibility: hidden;" />
                            }
                        </div>
                    </div>
                    }
                </div>
                }
            </div>
        </div>
    </div>
    } @if (getPlanPurposeLotSync()) {
    <div class="group">
        <div class="container-fluid well">
            <div class="form-inline">
                <div class="form-group">
                    <div class="nlr-checkbox mgt20">
                        <div
                            title="If an Application for new titles document has been lodged, selecting this option for a CAD Plan will assign a High Priority to Plan Examination. Portal Plans are already assigned a High Priority.">
                            <input
                                type="checkbox"
                                id="applicationForTitlesLodged"
                                name="applicationForTitlesLodged"
                                [disabled]="isReadonly()"
                                [(ngModel)]="applicationForTitlesLodged" />
                            <label for="applicationForTitlesLodged">Readiness to proceed</label>
                        </div>
                    </div>
                </div>
                @if (applicationForTitlesLodged) {
                <div class="form-group">
                    <label
                        for="additionalsApplicationForTitlesDocumentIdentifier"
                        class="control-label required-input"
                        >Application document</label
                    >
                    <div
                        class="input-group auto-size-form-control"
                        [ngClass]="{'has-error': applicationForTitlesDocumentIdentifier | formFieldHasError}">
                        <span class="input-group-addon">
                            <i
                                class="nlrp-icon nlrp-icon-edit"
                                id="editApplicationForTitlesLodged"></i>
                        </span>
                        <input
                            type="text"
                            id="additionalsApplicationForTitlesDocumentIdentifier"
                            name="additionalsApplicationForTitlesDocumentIdentifier"
                            class="form-control"
                            [(ngModel)]="additionalsViewModel.applicationForTitlesDocumentIdentifier"
                            [nlrPattern]="documentPattern"
                            [required]="applicationForTitlesLodged"
                            nlrUppercase
                            tooltip-placement="right"
                            size="12"
                            maxlength="12"
                            autocomplete="off"
                            title="The application for new titles document number."
                            #applicationForTitlesDocumentIdentifier="ngModel" />
                    </div>
                    @if (applicationForTitlesDocumentIdentifier | formFieldHasError) {
                    <div class="help-block">
                        <span>Error!</span>
                        <span>Incorrect entry, format should be document prefix and number e.g. M123456, T8606/1961.</span>
                    </div>
                    }
                </div>
                }
            </div>
        </div>
    </div>
    }
    <div class="group">
        <div class="container-fluid well">
            <h5>Additional attachments</h5>
            <table class="table table-striped">
                <thead>
                    <tr class="default">
                        <td
                            nowrap
                            class="col-md-3"
                            title=""
                            >Type</td
                        >
                        <td
                            nowrap
                            class="col-md-2"
                            title=""
                            >File</td
                        >
                        <td
                            nowrap
                            class="col-md-4"
                            title=""
                            >Details</td
                        >
                        <td
                            nowrap
                            class="col-md-2"
                            title=""
                            >Added</td
                        >
                        <td
                            nowrap
                            class="custom-header"
                            title="Actions"></td>
                    </tr>
                </thead>
                <tbody>
                    @for (lodgedAdditional of this.additionalsViewModel.lodgedAdditionalDocuments; track lodgedAdditional) {
                    <tr>
                        <td class="text-left">{{getAttachmentName(lodgedAdditional.attachmentType)}}</td>
                        <td class="text-left">{{lodgedAdditional.fileName}}</td>
                        <td class="text-left">{{lodgedAdditional.details}}</td>
                        <td class="text-left">{{lodgedAdditional.dateTimeAdded | date:"dd-MMM-yyyy HH:mm"}}</td>
                        <td
                            class="vertical-middle text-right"
                            style="width: 170px;padding:0px">
                            @if (lodgedAdditional.fileName && canPreview(lodgedAdditional.fileName)) {
                            <i
                                class="nlrp-icon nlrp-icon-view-attachment"
                                (click)="preview(lodgedAdditional)"
                                tabindex="0"
                                title="View attachment"
                                [disabled]="!lodgeAdditionalsEnabled"></i>
                            }
                        </td>
                    </tr>
                    } @for (newAdditional of this.additionalsViewModel.newAdditionalDocuments; track newAdditional; let i = $index) {
                    <tr>
                        <td class="text-left">
                            <div class="input-group">
                                <ng-select
                                    class="nlr-ng-select"
                                    [searchable]="false"
                                    [clearable]="false"
                                    [name]="'attachmentType' + i"
                                    [id]="'attachmentType' + i"
                                    placeholder="Select"
                                    [items]="attachmentTypeOptions"
                                    [ngModel]="newAdditional.attachmentTypeSelect"
                                    #attachmentType="ngModel"
                                    bindLabel="name"
                                    (change)="updateSelectedAttachType(attachmentType.value, i)"
                                    required>
                                    @for (at of attachmentTypeOptions; track at) {
                                    <ng-option [value]="at.type">{{at.name}}</ng-option>
                                    }
                                </ng-select>
                            </div>
                        </td>
                        <td class="text-left">
                            {{newAdditional.fileName}} @if (newAdditional.attachmentType && !newAdditional.fileName) {
                            <div class="help-block">
                                <span>Error!</span>
                                <span>Please upload a file.</span>
                            </div>
                            }
                        </td>
                        <td class="text-left">
                            <div class="input-group">
                                <span class="input-group-addon corner">
                                    <i class="nlrp-icon nlrp-icon-edit corner-icon"></i>
                                </span>
                                <textarea
                                    class="form-control"
                                    [name]="'newAdditionalDetails' + i"
                                    [id]="'newAdditionalDetails' + i"
                                    rows="2"
                                    cols="30"
                                    maxlength="100"
                                    [(ngModel)]="newAdditional.details"
                                    title="Additional details">
                                </textarea>
                            </div>
                        </td>
                        <td class="text-left">{{newAdditional.dateTimeAdded | date:"dd-MMM-yyyy HH:mm"}}</td>
                        <td
                            class="vertical-middle text-right"
                            style="width: 170px;padding:0px">
                            @if (newAdditional.attachmentType) {
                            <i
                                class="nlrp-icon nlrp-icon-paper-clip upload-paperclip"
                                (click)="triggerAttachFileModal(newAdditional)"
                                tabindex="0"
                                title="Click to attach a file"
                                [class.disabled]="!lodgeAdditionalsEnabled">
                            </i>
                            }
                            <i
                                class="nlrp-icon nlrp-icon-trash"
                                (click)="clearAdditional(newAdditional)"
                                tabindex="0"
                                title="Clear selected attachment"
                                [class.disabled]="!lodgeAdditionalsEnabled"></i>
                            @if (newAdditional.fileName) {
                            <i
                                class="nlrp-icon nlrp-icon-view-attachment"
                                (click)="canPreview(newAdditional.fileName) && preview(newAdditional)"
                                tabindex="0"
                                title="View attachment"
                                [class.disabled]="!lodgeAdditionalsEnabled"></i>
                            }
                        </td>
                    </tr>
                    @if (hasValidationErrorsOrWarnings(newAdditional)) {
                    <tr></tr>
                    } @if (hasValidationErrorsOrWarnings(attachment)) {
                    <tr
                        [ngClass]="{'has-error-bottom': hasValidationErrors(attachment),
                                       'has-warning-bottom': hasValidationWarnings(attachment) &&
                                       !hasValidationErrors(attachment)}">
                        <td colspan="6">
                            <evidence-validation [attachment]="newAdditional"></evidence-validation>
                        </td>
                    </tr>
                    } }
                </tbody>
            </table>
            <div class="row mgt0">
                <div class="col-xs-12">
                    <button
                        id="addAdditionalDocumentBtn"
                        type="button"
                        class="btn btn-default nlr-btn-sm validate"
                        (click)="addAdditionalDocument()"
                        [disabled]="isAdditionalDocumentDisabled()"
                        title="Add additional document">
                        Add
                        <i
                            class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                            style="display: none;"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <div class="row buttons">
            <div class="col-xs-12">
                <button
                    id="lodgeAdditionalsBtn"
                    type="button"
                    class="btn btn-default nlr-btn-sm validate"
                    (click)="lodge()"
                    [disabled]="!lodgeAdditionalsEnabled || !canLodge()"
                    title="Submits the selected additional documents">
                    Submit
                    <i
                        class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                        style="display: none;"></i>
                </button>

                <button
                    id="cancelAdditionalsBtn"
                    type="button"
                    class="btn btn-warning nlr-btn-sm"
                    (click)="cancel()"
                    title="Clears all data on the Additonals screen"
                    [disabled]="isCancelDisabled()">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</form>
